module.exports = __webpack_public_path__ + "static/media/avatar_woman.71bdcf6a.png";